// 表单校验
export const GoodsformCheck = { // 商品校验
    data() {
        return {
            goodsRules: {
                namec: [{ required: true, message: "中文名称不能为空" }],
                // goodstypeid: [{ required: true, message: "商品类型不能为空" }],
                brand: [{ required: true, message: "品牌不能为空" }],
                // hsCode: [{ required: true, message: "海关编码不能为空" }],
                // purposec: [{ required: true, message: "用途不能为空" }],
                isHasMagnetic: [{ required: true, message: "是否带磁不能为空" }],
                // salesUrl: [{ required: false, message: "销售连接不能为空" }],
                picUrl: [{ required: true, message: "请上传图片" }],

                namee: [{ required: true, message: "英文名称不能为空" }],
                // model: [{ required: true, message: "型号不能为空" }],
                declaredValue: [{ required: true, message: "商品货值不能为空" }],
                // materialc: [{ required: true, message: "材质不能为空" }],
                isHasBattery: [{ required: true, message: "是否带电不能为空" }],
                isPowderLiquid: [{ required: true, message: "是否液体粉末不能为空" }],
            },
        }
    },
    created: function () {

    },
    methods: {

    },
    mounted() {
    }
}
export const BoxformCheck = { // 箱子校验
    data() {
        return {
            moreNotOjb: {
                // Nottypeid: [
                //     { required: true, message: "货物类型不能为空" },
                // ],
                // Notponum: [
                //     { required: true, message: "货件追踪号不能为空" },
                //     {
                //         validator: (rule, value, callback) => {
                //             if (value.length > 8 || value.length < 8) {
                //                 callback(new Error("长度只能为8个字符"));
                //             } else {
                //                 var reg = /^[a-zA-Z0-9]+$/;
                //                 if (!reg.test(value)) {
                //                     callback(new Error("只能为数字和字母"));
                //                 } else {
                //                     callback();
                //                 }
                //             }
                //         },
                //         trigger: "change",
                //     },
                // ],
                // Notgoodsnum: [{ required: true, message: "商户号不能为空" }],
                Notboxnum: [
                    { required: true, message: "箱号不能为空" },
                    {
                        validator: (rule, value, callback) => {
                            var index = value.toLowerCase().indexOf('fba');
                            if (this.billType) {
                                if (index == 0) {
                                    if (value.length < 19 || value.length > 19) {
                                        callback(new Error("长度必须为19位字符"));
                                    } else {
                                        callback();
                                    }
                                } else {
                                    callback(new Error("必须以FBA字符开头"));
                                }
                            } else {
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
                // goodsNotname: [{ required: true, message: "品名不能为空" }],
                // Notweight: [
                //     { required: true, message: "重量不能为空" },
                //     {
                //         validator: (rule, value, callback) => {
                //             if (value.length > 15 || value.length < 1) {
                //                 callback(new Error("长度只能为1-15个字符"));
                //             } else {
                //                 var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                //                 if (value <= 0) {
                //                     callback(new Error("重量只能大于零且保留最多两位小数"));
                //                 }
                //                 if (!reg.test(value)) {
                //                     callback(new Error("重量只能大于零且保留最多两位小数"));
                //                 } else {
                //                     callback();
                //                 }
                //             }
                //         },
                //         trigger: "change",
                //     },
                // ],
                // Notlength: [
                //     { required: true, message: "长度不能为空" },
                //     {
                //         validator: (rule, value, callback) => {
                //             if (value.length > 15 || value.length < 1) {
                //                 callback(new Error("长度只能为1-15个字符"));
                //             } else {
                //                 var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                //                 if (value <= 0) {
                //                     callback(new Error("长度只能大于零且保留最多两位小数"));
                //                 }
                //                 if (!reg.test(value)) {
                //                     callback(new Error("长度只能大于零且保留最多两位小数"));
                //                 } else {
                //                     callback();
                //                 }
                //             }
                //         },
                //         trigger: "change",
                //     },
                // ],
                // Notwidth: [
                //     { required: true, message: "宽度不能为空" },
                //     {
                //         validator: (rule, value, callback) => {
                //             if (value.length > 15 || value.length < 1) {
                //                 callback(new Error("长度只能为1-15个字符"));
                //             } else {
                //                 var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                //                 if (!reg.test(value)) {
                //                     callback(new Error("宽度只能大于零且保留最多两位小数"));
                //                 } else {
                //                     callback();
                //                 }
                //             }
                //         },
                //         trigger: "change",
                //     },
                // ],
                // Notheight: [
                //     { required: true, message: "高度不能为空" },
                //     {
                //         validator: (rule, value, callback) => {
                //             if (value.length > 15 || value.length < 1) {
                //                 callback(new Error("长度只能为1-15个字符"));
                //             } else {
                //                 var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                //                 if (!reg.test(value)) {
                //                     callback(new Error("高度只能大于零且保留最多两位小数"));
                //                 } else {
                //                     callback();
                //                 }
                //             }
                //         },
                //         trigger: "change",
                //     },
                // ],
            },
        }
    },
    created: function () {

    },
    methods: {

    },
    mounted() {

    }
}



// WEBPACK FOOTER //
// ./src/components/PersonalCenter/FBAheader/FBAChangedata/fromCheck.js